import { render, staticRenderFns } from "./TabelaPacoteHonorario.vue?vue&type=template&id=7436eb4e"
import script from "./TabelaPacoteHonorario.vue?vue&type=script&lang=js"
export * from "./TabelaPacoteHonorario.vue?vue&type=script&lang=js"
import style0 from "./TabelaPacoteHonorario.vue?vue&type=style&index=0&id=7436eb4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports